import { memo, MouseEvent } from 'react'
import styled from '@emotion/styled'
import Cytoscape from 'cytoscape'
import cola from 'cytoscape-cola'
import cytoscapePopper, { PopperOptions, RefElement } from 'cytoscape-popper'
import { useAtomValue } from 'jotai'
import { createPopper, Instance as PooperInstance } from '@popperjs/core'

import { AMOwnershipGraphVisualNode } from 'src/common-services'
import { Colors } from 'src/components/theme'
import * as atoms from 'src/v2/state/owner-reveal'
import { GraphWidget } from 'src/v2/components/graph-widget'

function popperFactory(ref: RefElement, content: HTMLElement, options?: PopperOptions): PooperInstance {
  const popperInstance = createPopper(ref, content, options)
  return popperInstance
}

Cytoscape.use(cola)
Cytoscape.use(cytoscapePopper(popperFactory))

const Container = styled.div`
  position: relative;
  cursor: default;
  display: flex;
  flex-direction: column;
  height: 100%;
  padding-left: 408px;
  background: ${Colors.neutral100};
`

export type SelectedNode = {
  id: string
  type: AMOwnershipGraphVisualNode['type']
  isGroupNode?: boolean
  graph?: any
}

export const GraphMapWidgetContent = memo(() => {
  const selectedEntityId = useAtomValue(atoms.selectedEntityId)
  const selectedParcelId = useAtomValue(atoms.selectedParcelId)
  const selectedId = selectedEntityId ?? selectedParcelId

  if (!selectedEntityId && !selectedParcelId) {
    return null
  }

  const handleContextMenu = (evt: MouseEvent<HTMLDivElement>) => {
    evt.preventDefault()
  }

  return (
    <Container onContextMenu={handleContextMenu}>
      {selectedId && <GraphWidget id={selectedId} type={selectedParcelId ? 'parcel' : 'entity'} />}
    </Container>
  )
})
